// Recovered compiled webpack factory 17828. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "workAsyncStorageInstance", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let n = (0, r(64054).createAsyncLocalStorage)();
}
